import { useAuth } from 'context/AuthContext';
import { useEffect, useState } from 'react';
import { IoIosClose } from 'react-icons/io';

import './styles.scss';
import FeedbackMandou from 'assets/img/comportamento/mandou.png';
import { getUserNotifications } from 'services/notifications.service';

export default function Notification() {
  const [notification, setNotification] = useState<any>();
  const [allNotification, setAllNotification] = useState<any>([]);

  const { user } = useAuth();

  async function handleClose() {
    if (allNotification?.length > 1) {
      const data = [...allNotification];
      setNotification(data[1]);
      const newData = data.slice(1);
      setAllNotification(newData);
    } else {
      setNotification(null);
      setAllNotification([]);
    }
  }

  async function loadData() {
    if (user) {
      const notifications = await getUserNotifications();
      if (notifications?.[0]) {
        setNotification(notifications[0]);
        setAllNotification(notification);
      }
    }
  }

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (!notification) return null;

  return (
    <div className="modal-news rb-modal-overlay rb-modal-overlay--top">
      <div className="rb-modal rb-modal--md">
        <button className="rb-modal__close" aria-label="Fechar" onClick={() => handleClose()}>
          <IoIosClose size={26} />
        </button>

        <div className="rb-modal__header">
          <div className="flex items-center justify-center mb-6">
            <img src={FeedbackMandou} alt="Imagem de feedback" className="w-[173px] block" />
          </div>
          {notification?.definition?.content !== 'rede' ? (
            <h1 className="rb-modal__title">uhul! {notification?.item?.name} concluído</h1>
          ) : (
            <h1 className="rb-modal__title">uhul! Você concluiu a ação:</h1>
          )}
        </div>

        {notification?.definition?.content !== 'rede' ? (
          <p className="rb-modal__text text-center">{notification?.definition?.content}</p>
        ) : (
          <p className="rb-modal__text text-center">{notification?.item?.name}</p>
        )}
      </div>
    </div>
  );
}
